import React, { useState } from "react";

const ContactInfo = (props) => {
  const [Mail, setMail] = useState("mailto:" + props.Candidate.email);
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const handleUnavailableData = (Data) => {
    if (Data === "" || Data === null || Data === undefined) {
      return translateText("not_available");
    } else {
      return Data;
    }
  };
  return (
    <div className="contact-modal">
      <div className="outline" onClick={() => props.Close()}></div>
      <div className="contact-modal-body">
        <section className="modal-head">
          {props.Candidate.imageThumbnailUrl === null ? (
            <span
              className="avatar"
              style={{ backgroundColor: props.Candidate.backgroundColorCode }}
            >
              <p style={{ color: props.Candidate.textColorCode }}>
                {props.Candidate.firstName.slice(0, 1).toUpperCase() +
                  props.Candidate.lastName.slice(0, 1).toUpperCase()}
              </p>
            </span>
          ) : (
            <img
              className="avatar avatar-image"
              src={props.Candidate.imageThumbnailUrl}
            />
          )}
          <section className="candidate-identity">
            <p className="candidate-name">
              {props.Candidate.firstName + " " + props.Candidate.lastName}
            </p>
            <p className="candidate-pos">
              {props.Candidate.currentPositionTitle}
            </p>
          </section>
          <i className="feather-x" onClick={() => props.Close()}></i>
        </section>
        <section className="contact-info-content">
          <div className="contact-row">
            <i className="feather-mail"></i>
            <section className="small-info">
              <p>{translateText("email")}</p>
              <p>{handleUnavailableData(props.Candidate.email)}</p>
            </section>
          </div>
          <div className="contact-row">
            <i className="feather-smartphone"></i>
            <section className="small-info">
              <p>{translateText("mobile")}</p>
              <p>{handleUnavailableData(props.Candidate.workMobile)}</p>
            </section>
          </div>
          <div className="contact-row">
            <i className="feather-phone"></i>
            <section className="small-info">
              <p>{translateText("work_phone")}</p>
              <p>{handleUnavailableData(props.Candidate.workPhone)}</p>
            </section>
          </div>
        </section>
        <section className="contact-actions">
          <span className="cancel" onClick={() => props.Close()}>
            <p>{translateText("cancel")}</p>
          </span>
          <a className="send-mail" href={Mail}>
            <p>{translateText("send_email")}</p>
          </a>
        </section>
      </div>
    </div>
  );
};

export default ContactInfo;
